// extracted by mini-css-extract-plugin
export default {"cardWithTabs":"Analytics_cardWithTabs__R5BGf"};